import React, { useState } from "react";
import SideBar from "../SideBar/sideBar";

const ScoreSimulator = () => {
    const FirstName = localStorage.getItem('firstName') || '';
    const LastName = localStorage.getItem('lastName') || '';
    const initials = `${FirstName.charAt(0)}${LastName.charAt(0)}`;
    const PlanTypeName = localStorage.getItem('PlanTypeName')

    return (
        <div className="flex h-100% bg-[#121212]">
            <SideBar />
            <main className="flex-1 overflow-y-auto p-6 min-h-screen">
                <div className="flex flex-col md:flex-row justify-between items-center mt-5 mb-4">
                    <h1 className="text-2xl md:text-3xl font-bold text-white">AI Score Simulator</h1>
                    <div className="ml-0 md:ml-[30.75rem] mt-4 md:mt-0">
                        {PlanTypeName?.includes('Lifetime Access') && (
                            <h1 className="text-white font-semibold">You Have Lifetime Access</h1>
                        )}
                    </div>
                    <div className="w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center mt-4 md:mt-0">
                        <span className="text-white font-bold">{initials}</span>
                    </div>
                </div>
                <div>
                    <iframe
                        style={{ width: '100%' }}
                        height="1600"
                        src="https://www.create.xyz/app/16abb338-b58c-42c6-993d-9313dcd424da"
                        title="FICO Score Simulator"
                        frameBorder="0">
                    </iframe>

                    {/* <iframe style="width: 100%;" height="569" src="https://www.create.xyz/app/16abb338-b58c-42c6-993d-9313dcd424da" title="FICO Score Simulator" frameBorder="0"></iframe> */}
                </div>
            </main>
        </div>
    )
}

export default ScoreSimulator